module.exports = __webpack_public_path__ + "assets/valance-standard-selected.f5ba9541.svg";